import ActionCreator from "../actionCreator";

export default {
    setTitle: ActionCreator("UI_SET_TITLE"),
    clearTitle: ActionCreator("UI_CLEAR_TITLE"),
    getSidelinks: ActionCreator("GET_SIDELINKS"),
    createSidelinks: ActionCreator("CREATE_SIDELINKS"),
    errorResponse: ActionCreator("ERROR_RESPONSE_SIDELINKS"),
};
